/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");


const ajaxHttp = require('appUtil/ajaxHttp');
const tip = require('components/base/pop/tip');
const icon = require('components/base/icon/icon');
const { apiPath } = require('appService/api');

const pop = resolve => require(['components/base/pop/pop'], resolve);

const { setBreadCrumb } = require('src/common/vuex/action/common');
const store = require('appVuex/store');
require('rootPath/src/common/components/lib/filter.js');

const template = require('./order-detail.tpl');
require('./order-detail.scss');

const orderDetail = {
  template,
  components:{
    pop
  },
  data(){
    return{
		  showPic: false,
      url: apiPath.charge.orderDetail,
      orStatusUrl: apiPath.charge.orderStatus,
		  orderDetailInfo: {},
		  baseInfo: {},
		  orderInfo: {},
		  chargeFees: {},
		  serviceFees: {},
		  totalFees: {},
      orderId: null,
      statusListObj: {}
		}
  },
  ready(){
    this.orderId = this.$route.query.orderID;
    this.getDetailData(); //获取订单详情信息
    this.getOrderStatusData(); //获取订单状态数据
  },
  methods:{
    getDetailData(){
		  ajaxHttp(this.url, {
        "type": "GET",
        "data": {"orderId": this.orderId}
      }).then((res) => {
			  this.orderDetailInfo = res.data;
			  this.baseInfo = this.orderDetailInfo.baseInfo;
			  this.orderInfo = this.orderDetailInfo.orderInfo;
			  this.totalFees = this.orderDetailInfo.totalFees;
			  this.chargeFees = this.orderDetailInfo.orderFees[0];
			  this.serviceFees = this.orderDetailInfo.orderFees[1];

        this.orderDetailInfo.avatar ? this.showPic = true : this.showPic = false;
		  }).catch((res) => {
			  // tip(res.messsage);
		  });
    },
    getOrderStatusData() {
      ajaxHttp(this.orStatusUrl, {})
      .then((res) => {
        this.statusListObj = res.data;
      }).catch((res) => {
      // tip(res.messsage);
      });
    },
    tipShow(event){
       $(".zclip-tip").addClass('mover-zclip');
    },
    tipHide(event){
      $(".zclip-tip").removeClass('mover-zclip');
    }
  },
  vuex: {
    actions: {
      setBreadCrumb
    }
  },
  filters: {
		filterData(val) {
      return (val==0 || val) ? val : "--"
    },
    duration(val) {
      let _val = val / 1000;
      return `${Math.ceil(_val/60)}`
    },
    filtersFees(val, type) {

		  let suffixArr = {
		    "amount": "元",
		    "consume": "度",
		    "perCount": "元每度",
		    "discount": "元"
		  }
	  	return type === "perCount" ? `${parseInt(val)}${suffixArr[type]}` : `${val}${suffixArr[type]}`
    },
    filtersService(val, type) {
      let suffixArr = {
        "amount": "元",
        "consume": "小时",
        "perCount": "元/每时",
        "discount": "元"
      }
      return type === "perCount" ? `${parseInt(val)}${suffixArr[type]}` : `${val}${suffixArr[type]}`
    },
    filtersFeesType(type) {
	  	return (type == "0" ? "充电费" : "服务费")
    },
    filterExtra(val) {
      if (!val) return "集团员工5折优惠"
    },
    filterCouponDesc(val) {
      if (!val) return "充电减免券"
    },
    filterStatus(val) {
      return (this.statusListObj[val] ? this.statusListObj[val] : "充电中")
    },
    filterCount(val) {
      return `${val}`
    }
  },
  store
}

module.exports = orderDetail;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/charge/order-detail/order-detail.js